import { useState, useEffect, useCallback } from 'react';
import { ctfClient } from '../../lib/contentful';

export function useGetSingleBlogPost(id) {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // wrap in useCallback so it's stable across renders
  const refresh = useCallback(async () => {
    if (!id) {
      setError('No post ID provided');
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const entry = await ctfClient.getEntry(id);
      const { sys, fields } = entry;
      // const bodyLines = fields.body.content.flatMap((block) =>
      //   block.content.map((node) => node.value)
      // );
      setPost({
        id: sys.id,
        title: fields.title,
        slug: fields.slug,
        excerpt: fields.excerpt || '',
        publishDate: fields.publishDate,
        authorName: fields.authorName || 'Unknown',
        coverImageUrl: fields.coverImage?.fields.file?.url || null,
        body: fields.body,
        keywords: fields.keywords || [],
      });
    } catch (err) {
      console.error('useGetSingleBlogPost error:', err);
      setError(err.message || 'Unknown error');
    } finally {
      setLoading(false);
    }
  }, [id]); // only re-create when `id` changes

  // now effect depends on `refresh` only
  useEffect(() => {
    refresh();
  }, [refresh]);

  return { post, loading, error, refresh };
}
